<!-- version 1.9-->

<template>
  <div>
    <div class="gridView">
      <b-overlay
        :show="loading"
        variant="light"
        spinner-type="grow"
        spinner-variant="warning"
        :opacity="0.5"
        blur="10px"
        rounded="sm"
      >
        <div class="card">
          <div class="card-header">
            <div class="row justify-content-between">
              <div
                class="col-md-9 col-sm-6 col-12 d-flex align-items-center"
                v-if="badgeFilter"
              >
                <ul class="nav justify-content-end nav-btns">
                  <template
                    v-for="(col, index) in columns"
                    v-if="col.type != 'action'"
                  >
                    <li
                      v-if="
                        gridView.filters[col.field] &&
                        gridView.filters[col.field].status
                      "
                      :key="index"
                    >
                      <span class="badge badge-pill" :class="badgeColor">
                        <i
                          class="fa fa-times"
                          @click="cancelFilter(col.field)"
                        ></i>
                        {{ col.label }} :
                        <b class="badge-text">
                          <template v-if="col.type === 'date'">
                            {{
                              $getDate(
                                gridView.filters[col.field].value,
                                "jYYYY/jM/jD",
                                "YYYY-MM-DD"
                              )
                            }}
                          </template>
                          <template v-else-if="col.type === 'time'">
                            {{ gridView.filters[col.field].value }}
                          </template>
                          <template v-else-if="col.type === 'dateTime'">
                            {{
                              $getDate(
                                gridView.filters[col.field].value,
                                "jYYYY/jM/jDTHH:mm:ss"
                              )
                            }}
                          </template>
                          <template v-else-if="col.type === 'dateFromTo'">
                            {{
                              $getDate(
                                gridView.filters[col.field].value.from,
                                "jYYYY/jM/jD",
                                "YYYY-MM-DD"
                              ) +
                              " تا " +
                              $getDate(
                                gridView.filters[col.field].value.to,
                                "jYYYY/jM/jD",
                                "YYYY-MM-DD"
                              )
                            }}
                          </template>
                          <template v-else-if="col.type === 'timeFromTo'">
                            {{
                              gridView.filters[col.field].value.from +
                              " تا " +
                              gridView.filters[col.field].value.to
                            }}
                          </template>
                          <template v-else-if="col.type === 'dateTimeFromTo'">
                            {{
                              $getDate(
                                gridView.filters[col.field].value.from,
                                "jYYYY/jM/jD"
                              ) +
                              "  تا  " +
                              $getDate(
                                gridView.filters[col.field].value.to,
                                "jYYYY/jM/jD"
                              )
                            }}
                          </template>
                          <template v-else-if="col.type === 'priceFromTo'">
                            {{
                              $getIRT(gridView.filters[col.field].value.from) +
                              "  تا  " +
                              $getIRT(gridView.filters[col.field].value.to)
                            }}
                          </template>
                          <template v-else-if="col.type === 'fromTo'">
                            {{
                              gridView.filters[col.field].value.from
                                ? gridView.filters[col.field].value.from
                                : "0" +
                                  "  تا  " +
                                  gridView.filters[col.field].value.to
                                ? gridView.filters[col.field].value.to
                                : "0"
                            }}
                          </template>
                          <template v-else>
                            {{
                              col.filterItems
                                ? Object.values(
                                    col.filterItems.find(
                                      (k) =>
                                        k.code ===
                                        gridView.filters[col.field].value
                                    )
                                  )[0]
                                : gridView.filters[col.field].value
                            }}
                          </template>
                        </b>
                      </span>
                    </li>
                  </template>
                </ul>
              </div>
              <div class="col-md-3 col-sm-6 col-12 d-flex justify-content-end">
                <button
                  class="btn btn-outline-gray btn-sm animated fadeInUp mr-1 ml-1"
                  v-show="excelExport"
                  @click="runExportExcel()"
                  title="خروجی اکسل از لیست"
                >
                  <i
                    class="fas fa-file-excel green"
                    style="color: #00c48d; margin-left: 10px"
                  ></i
                  >خروجی اکسل
                </button>
                <button
                  v-show="adFilter"
                  class="btn btn-outline-gray btn-sm animated fadeInUp d-flex align-items-center"
                  title="جستجو پیشرفته"
                  v-if="adFilter"
                  @click="$bvModal.show('adFilterModal')"
                >
                  <i
                    class="fas fa-search blue"
                    style="color: #ff8030; margin-left: 10px"
                  ></i
                  >جستجو
                </button>
              </div>
            </div>
          </div>

          <div
            class="card-body"
            :class="{ 'min-bode-height': !gridView.data.length }"
          >
            <div class="table-responsive">
              <table class="table align-items-center">
                <thead>
                  <tr>
                    <!--columns th-->
                    <th
                      class="col-title text-center pr-0"
                      v-html="'#'"
                      v-if="rowCounter"
                    ></th>
                    <th
                      class="col-title"
                      v-for="(col, index) in columns"
                      v-html="col.label"
                      :title="col.label"
                      :key="index"
                      v-if="col.display"
                      :class="col.sortable ? setSortClass(col.field) : ''"
                      @click="col.sortable ? setSort(col.field) : ''"
                    ></th>
                  </tr>
                  <!--filter row-->
                  <tr class="filter rowFilter" v-if="rowFilter">
                    <th v-if="rowCounter"></th>
                    <th
                      v-if="col.display"
                      v-for="(col, index) in columns"
                      :key="index"
                    >
                      <template v-if="col.rowFilter">
                        <template v-if="col.type === 'date'">
                          <input
                            type="text"
                            class="form-control align"
                            :id="col.field + '-' + 'rowDate'"
                            :value="
                              $getDate(
                                gridView.filters[col.field].value,
                                'jYYYY/jM/jD',
                                'YYYY-MM-DD'
                              )
                            "
                            placeholder="تاریخ"
                          />
                          <date-picker
                            v-model="gridView.filters[col.field].value"
                            type="date"
                            locale="fa,en"
                            format="YYYY-MM-DD"
                            display-format="jD jMMMM jYYYY"
                            :auto-submit="true"
                            color="dimgray"
                            @change="
                              runFilter(gridView.filters[col.field].value)
                            "
                            :element="col.field + '-' + 'rowDate'"
                          />
                        </template>
                        <template v-if="col.type === 'time'">
                          <input
                            type="text"
                            class="form-control align"
                            :id="col.field + '-' + 'rowTime'"
                            :value="gridView.filters[col.field].value"
                            placeholder="تاریخ"
                          />
                          <date-picker
                            v-model="gridView.filters[col.field].value"
                            type="time"
                            locale="fa,en"
                            format="HH:mm:ss"
                            display-format="HH:mm:ss"
                            :auto-submit="true"
                            color="dimgray"
                            @change="
                              runFilter(gridView.filters[col.field].value)
                            "
                            :element="col.field + '-' + 'rowTime'"
                          />
                        </template>
                        <template v-if="col.type === 'dateTime'">
                          <input
                            type="text"
                            class="form-control align"
                            :id="col.field + '-' + 'rowDateTime'"
                            :value="
                              $getDate(
                                gridView.filters[col.field].value,
                                'jYYYY/jM/jDTHH:mm:ss'
                              )
                            "
                            placeholder="تاریخ"
                          />
                          <date-picker
                            v-model="gridView.filters[col.field].value"
                            type="dateTime"
                            locale="fa,en"
                            format="YYYY-MM-DDTHH:mm:ssZ"
                            display-format="jD jMMMM jYYYY"
                            :auto-submit="true"
                            color="dimgray"
                            @change="
                              runFilter(gridView.filters[col.field].value)
                            "
                            :element="col.field + '-' + 'rowDateTime'"
                          />
                        </template>
                        <template v-if="col.type === 'dateFromTo'">
                          <input
                            type="text"
                            class="form-control mb-1"
                            :id="col.field + '-' + 'rowDateFrom'"
                            :value="
                              $getDate(
                                gridView.filters[col.field].value.from,
                                'jYYYY/jM/jD',
                                'YYYY-MM-DD'
                              )
                            "
                            placeholder="از تاریخ"
                          />
                          <date-picker
                            v-model="gridView.filters[col.field].value.from"
                            type="date"
                            locale="fa,en"
                            format="YYYY-MM-DD"
                            display-format="jD jMMMM jYYYY"
                            :auto-submit="true"
                            color="dimgray"
                            @change="loadGridView"
                            :element="col.field + '-' + 'rowDateFrom'"
                          />

                          <input
                            type="text"
                            class="form-control"
                            :id="col.field + '-' + 'rowDateTo'"
                            :value="
                              $getDate(
                                gridView.filters[col.field].value.to,
                                'jYYYY/jM/jD',
                                'YYYY-MM-DD'
                              )
                            "
                            placeholder="تا تاریخ"
                          />
                          <date-picker
                            v-model="gridView.filters[col.field].value.to"
                            type="date"
                            locale="fa,en"
                            format="YYYY-MM-DD"
                            display-format="jD jMMMM jYYYY"
                            :auto-submit="true"
                            color="dimgray"
                            @change="
                              runFilter(gridView.filters[col.field].value.to)
                            "
                            :element="col.field + '-' + 'rowDateTo'"
                          />
                        </template>
                        <template v-if="col.type === 'timeFromTo'">
                          <input
                            type="text"
                            class="form-control mb-1"
                            :id="col.field + '-' + 'rowTimeFrom'"
                            :value="gridView.filters[col.field].value.from"
                            placeholder="از ساعت"
                          />
                          <date-picker
                            v-model="gridView.filters[col.field].value.from"
                            type="time"
                            locale="fa,en"
                            format="HH:mm:ss"
                            display-format="HH:mm:ss"
                            :auto-submit="true"
                            color="dimgray"
                            @change="loadGridView"
                            :element="col.field + '-' + 'rowTimeFrom'"
                          />

                          <input
                            type="text"
                            class="form-control"
                            :id="col.field + '-' + 'rowTimeTo'"
                            :value="gridView.filters[col.field].value.to"
                            placeholder="تا ساعت"
                          />
                          <date-picker
                            v-model="gridView.filters[col.field].value.to"
                            type="time"
                            locale="fa,en"
                            format="HH:mm:ss"
                            display-format="HH:mm:ss"
                            :auto-submit="true"
                            color="dimgray"
                            @change="
                              runFilter(gridView.filters[col.field].value.to)
                            "
                            :element="col.field + '-' + 'rowTimeTo'"
                          />
                        </template>
                        <template v-if="col.type === 'dateTimeFromTo'">
                          <input
                            type="text"
                            class="form-control mb-1"
                            :id="col.field + '-' + 'rowDateTimeFrom'"
                            :value="
                              $getDate(
                                gridView.filters[col.field].value.from,
                                'jYYYY/jM/jD'
                              )
                            "
                            placeholder="از تاریخ"
                          />
                          <date-picker
                            v-model="gridView.filters[col.field].value.from"
                            type="date"
                            locale="fa,en"
                            format="YYYY-MM-DDT00:00:00Z"
                            display-format="jD jMMMM jYYYY"
                            :auto-submit="true"
                            color="dimgray"
                            @change="loadGridView"
                            :element="col.field + '-' + 'rowDateTimeFrom'"
                          />

                          <input
                            type="text"
                            class="form-control"
                            :id="col.field + '-' + 'rowDateTimeTo'"
                            :value="
                              $getDate(
                                gridView.filters[col.field].value.to,
                                'jYYYY/jM/jD'
                              )
                            "
                            placeholder="تا تاریخ"
                          />
                          <date-picker
                            v-model="gridView.filters[col.field].value.to"
                            type="date"
                            locale="fa,en"
                            format="YYYY-MM-DDT23:59:59Z"
                            display-format="jD jMMMM jYYYY"
                            :auto-submit="true"
                            color="dimgray"
                            @change="
                              runFilter(gridView.filters[col.field].value.to)
                            "
                            :element="col.field + '-' + 'rowDateTimeTo'"
                          />
                        </template>
                        <template v-if="col.type === 'priceFromTo'">
                          <input
                            class="form-control mb-1"
                            placeholder="از مبلغ"
                            v-model="gridView.filters[col.field].value.from"
                            @keyup="
                              inputKeyUp(
                                col.field,
                                gridView.filters[col.field].value.from
                              )
                            "
                            @keydown="inputKeyDown"
                          />
                          <input
                            class="form-control"
                            placeholder="تا مبلغ"
                            v-model="gridView.filters[col.field].value.to"
                            @keyup="
                              inputKeyUp(
                                col.field,
                                gridView.filters[col.field].value.to
                              )
                            "
                            @keydown="inputKeyDown"
                          />
                        </template>
                        <template v-if="col.type === 'fromTo'">
                          <input
                            class="form-control mb-1"
                            placeholder="از"
                            v-model.number="
                              gridView.filters[col.field].value.from
                            "
                            @keyup="
                              inputKeyUp(
                                col.field,
                                gridView.filters[col.field].value.from
                              )
                            "
                            @keydown="inputKeyDown"
                          />
                          <input
                            class="form-control"
                            placeholder="تا"
                            v-model.number="
                              gridView.filters[col.field].value.to
                            "
                            @keyup="
                              inputKeyUp(
                                col.field,
                                gridView.filters[col.field].value.to
                              )
                            "
                            @keydown="inputKeyDown"
                          />
                        </template>
                        <template v-if="col.type === 'select'">
                          <select
                            v-if="col.rowFilter && col.filterItems"
                            class="form-control align"
                            v-model="gridView.filters[col.field].value"
                            @change="
                              runFilter(gridView.filters[col.field].value)
                            "
                          >
                            <option
                              v-for="(item, index) in col.filterItems"
                              :value="item.code"
                              :key="index"
                              v-html="item.name"
                            ></option>
                          </select>
                        </template>
                        <template v-if="col.type === 'text'">
                          <input
                            class="form-control align"
                            type="text"
                            :placeholder="col.placeholder"
                            v-model="gridView.filters[col.field].value"
                            @change="
                              runFilter(gridView.filters[col.field].value)
                            "
                            @keyup="
                              inputKeyUp(
                                col.field,
                                gridView.filters[col.field].value
                              )
                            "
                            @keydown="inputKeyDown"
                          />
                        </template>
                      </template>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in gridView.data"
                    class="animated fadeIn faster"
                    :class="'delay-0' + index + 's'"
                    :key="index"
                  >
                    <td
                      class="text-center"
                      v-html="
                        (gridView.page - 1) * gridView.pageSize + index + 1
                      "
                      v-if="rowCounter"
                    ></td>
                    <template v-for="col in columns">
                      <slot
                        v-if="$scopedSlots[col.field] && col.display"
                        :name="col.field"
                        :value="item"
                      ></slot>
                      <td
                        v-else
                        v-show="col.display"
                        v-html="item[col.field]"
                      ></td>
                    </template>
                  </tr>
                  <tr v-if="url && !gridView.data.length && !gridView.loading">
                    <td
                      :colspan="columns.length"
                      class="text-center empty"
                      @click="loadGridView"
                    >
                      <svg
                        class="empty"
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="512px"
                        height="512px"
                        viewBox="0 0 512 512"
                        style="enable-background: new 0 0 512 512"
                        xml:space="preserve"
                      >
                        <g>
                          <path
                            d="M480,320v128H32V320h78.859l64.016,96h162.25l64-96H480 M384,32H128L0,288v192h512V288L384,32L384,32z M35.781,288l112-224
                                                    h216.438l112,224H384l-64,96H192l-64.016-96H35.781L35.781,288z"
                          />
                        </g>
                      </svg>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="card-footer">
            <div
              v-show="url"
              class="row justify-content-center align-items-center py-3"
            >
              <div
                class="col-md col-sm-5 col-12 pb-2 p-md-0 d-flex justify-content-start"
              >
                <p class="m-0">
                  نمایش صفحه
                  <input
                    class="page_number"
                    style="height: 25px !important"
                    v-model="gridView.page"
                  />
                  از
                  <span class="pl-1 pr-1">{{
                    Math.ceil(
                      this.gridView.totalItemsCount / this.gridView.pageSize
                    )
                  }}</span>
                  صفحه / کل {{ gridView.totalItemsCount }} ردیف
                </p>
              </div>

              <div
                class="col-md col-sm-4 col-6 d-flex justify-content-center"
                v-if="gridView.totalItemsCount > gridView.pageSize"
              >
                <b-pagination
                  class="m-0 p-0"
                  v-model="gridView.page"
                  :total-rows="gridView.totalItemsCount"
                  :per-page="gridView.pageSize"
                  aria-controls="my-table"
                ></b-pagination>
              </div>

              <div
                class="col-md-3 col-sm-3 col-12 d-flex mt-3 mt-md-0 justify-content-end"
              >
                <label class="m-0">نمایش</label>
                <select
                  class="form-control"
                  style="height: 25px !important"
                  v-model="gridView.pageSize"
                >
                  <option :value="15">15</option>
                  <option :value="30">30</option>
                  <option :value="60">60</option>
                  <option :value="90">90</option>
                  <option :value="120">120</option>
                </select>
                <label class="m-0">ردیف</label>
              </div>
            </div>
            <div
              v-show="!url"
              class="row justify-content-center align-items-center p-5"
            >
              <p style="color: #d5dae8; font-size: 20px">API NOT SET</p>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
    <!-- Modal -->
    <b-modal id="adFilterModal" scrollable hide-footer>
      <template v-slot:modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5 style="font-size: 15px">جستجو پیشرفته</h5>
        <i
          @click="close()"
          class="fa fa-window-close"
          style="cursor: pointer"
        ></i>
      </template>

      <div v-for="(col, index) in columns" :key="index">
        <template v-if="col.adFilter">
          <div class="form-group row" v-if="col.type == 'date'">
            <label class="col-sm-3 col-form-label" v-html="col.label"></label>
            <div class="col-sm-9 d-flex justify-content-between">
              <input
                type="text"
                class="form-control"
                :id="col.field + '-' + 'date'"
                :value="
                  $getDate(
                    gridView.filters[col.field].value,
                    'jYYYY/jM/jD',
                    'YYYY-MM-DD'
                  )
                "
                placeholder="تاریخ"
              />

              <date-picker
                v-model="gridView.filters[col.field].value"
                type="date"
                locale="fa,en"
                format="YYYY-MM-DD"
                display-format="jD jMMMM jYYYY"
                :auto-submit="true"
                color="dimgray"
                :element="col.field + '-' + 'date'"
              >
              </date-picker>
            </div>
          </div>
          <div class="form-group row" v-else-if="col.type == 'time'">
            <label class="col-sm-3 col-form-label" v-html="col.label"></label>
            <div class="col-sm-9 d-flex justify-content-between">
              <input
                type="text"
                class="form-control"
                :id="col.field + '-' + 'time'"
                :value="gridView.filters[col.field].value"
                placeholder="تاریخ"
              />

              <date-picker
                v-model="gridView.filters[col.field].value"
                type="time"
                locale="fa,en"
                format="HH:mm:ss"
                display-format="HH:mm:ss"
                :auto-submit="true"
                color="dimgray"
                :element="col.field + '-' + 'time'"
              >
              </date-picker>
            </div>
          </div>
          <div class="form-group row" v-else-if="col.type == 'dateTime'">
            <label class="col-sm-3 col-form-label" v-html="col.label"></label>
            <div class="col-sm-9 d-flex justify-content-between">
              <input
                type="text"
                class="form-control"
                :id="col.field + '-' + 'dateTime'"
                :value="
                  $getDate(
                    gridView.filters[col.field].value,
                    'jYYYY/jM/jDTHH:mm:ss'
                  )
                "
                placeholder="تاریخ"
              />

              <date-picker
                v-model="gridView.filters[col.field].value"
                type="dateTime"
                locale="fa,en"
                format="YYYY-MM-DDTHH:mm:ssZ"
                display-format="jD jMMMM jYYYY"
                :auto-submit="true"
                color="dimgray"
                :element="col.field + '-' + 'date'"
              >
              </date-picker>
            </div>
          </div>
          <div
            class="form-group row two-input"
            v-else-if="col.type == 'dateFromTo'"
          >
            <label class="col-sm-3 col-form-label" v-html="col.label"></label>
            <div class="col-sm-9 d-flex justify-content-between">
              <input
                type="text"
                class="form-control two-input"
                :id="col.field + '-' + 'fromDate'"
                :value="
                  $getDate(
                    gridView.filters[col.field].value.from,
                    'jYYYY/jM/jD',
                    'YYYY-MM-DD'
                  )
                "
                placeholder="از تاریخ"
              />

              {{ gridView.filters[col.field].value.from }}

              <date-picker
                v-model="gridView.filters[col.field].value.from"
                type="date"
                locale="fa,en"
                format="YYYY-MM-DD"
                display-format="jD jMMMM jYYYY"
                :auto-submit="true"
                color="dimgray"
                :element="col.field + '-' + 'fromDate'"
              >
              </date-picker>

              <input
                type="text"
                class="form-control two-input"
                :id="col.field + '-' + 'toDate'"
                :value="
                  $getDate(
                    gridView.filters[col.field].value.to,
                    'jYYYY/jM/jD',
                    'YYYY-MM-DD'
                  )
                "
                placeholder="تا تاریخ"
              />

              <date-picker
                v-model="gridView.filters[col.field].value.to"
                type="date"
                locale="fa,en"
                format="YYYY-MM-DD"
                display-format="jD jMMMM jYYYY"
                :auto-submit="true"
                color="dimgray"
                :element="col.field + '-' + 'toDate'"
              >
              </date-picker>
            </div>
          </div>
          <div
            class="form-group row two-input"
            v-else-if="col.type == 'timeFromTo'"
          >
            <label class="col-sm-3 col-form-label" v-html="col.label"></label>
            <div class="col-sm-9 d-flex justify-content-between">
              <input
                type="text"
                class="form-control two-input"
                :id="col.field + '-' + 'TimeFrom'"
                :value="gridView.filters[col.field].value.from"
                placeholder="از ساعت"
              />
              <date-picker
                v-model="gridView.filters[col.field].value.from"
                type="time"
                locale="fa,en"
                format="HH:mm:ss"
                display-format="HH:mm:ss"
                :auto-submit="true"
                color="dimgray"
                :element="col.field + '-' + 'TimeFrom'"
              />
              <input
                type="text"
                class="form-control two-input"
                :id="col.field + '-' + 'TimeTo'"
                :value="gridView.filters[col.field].value.to"
                placeholder="تا ساعت"
              />
              <date-picker
                v-model="gridView.filters[col.field].value.to"
                type="time"
                locale="fa,en"
                format="HH:mm:ss"
                display-format="HH:mm:ss"
                :auto-submit="true"
                color="dimgray"
                :element="col.field + '-' + 'TimeTo'"
              />
            </div>
          </div>
          <div
            class="form-group row two-input"
            v-else-if="col.type == 'dateTimeFromTo'"
          >
            <label class="col-sm-3 col-form-label" v-html="col.label"></label>
            <div class="col-sm-9 d-flex justify-content-between">
              <input
                type="text"
                class="form-control two-input"
                :id="col.field + '-' + 'fromDateTime'"
                :value="
                  $getDate(
                    gridView.filters[col.field].value.from,
                    'jYYYY/jM/jD'
                  )
                "
                placeholder="از تاریخ"
              />

              <date-picker
                v-model="gridView.filters[col.field].value.from"
                type="date"
                locale="fa,en"
                format="YYYY-MM-DDT00:00:00Z"
                display-format="jD jMMMM jYYYY"
                :auto-submit="true"
                color="dimgray"
                :element="col.field + '-' + 'fromDateTime'"
              >
              </date-picker>

              <input
                type="text"
                class="form-control two-input"
                :id="col.field + '-' + 'toDateTime'"
                :value="
                  $getDate(gridView.filters[col.field].value.to, 'jYYYY/jM/jD')
                "
                placeholder="تا تاریخ"
              />

              <date-picker
                v-model="gridView.filters[col.field].value.to"
                type="date"
                locale="fa,en"
                format="YYYY-MM-DDT00:00:00Z"
                display-format="jD jMMMM jYYYY"
                :auto-submit="true"
                color="dimgray"
                :element="col.field + '-' + 'toDateTime'"
              >
              </date-picker>
            </div>
          </div>
          <div
            class="form-group row two-input"
            v-else-if="col.type == 'priceFromTo'"
          >
            <label class="col-sm-3 col-form-label" v-html="col.label"></label>
            <div class="col-sm-9 d-flex justify-content-between">
              <input
                type="text"
                :name="col.field"
                class="form-control two-input"
                v-model="gridView.filters[col.field].value.from"
                placeholder="از مبلغ"
              />

              <input
                type="text"
                :name="col.field"
                class="form-control two-input"
                v-model="gridView.filters[col.field].value.to"
                placeholder="تا مبلغ"
              />
            </div>
          </div>
          <div
            class="form-group row two-input"
            v-else-if="col.type == 'fromTo'"
          >
            <label class="col-sm-3 col-form-label" v-html="col.label"></label>
            <div class="col-sm-9 d-flex justify-content-between">
              <input
                type="text"
                :name="col.field"
                class="form-control two-input"
                v-model="gridView.filters[col.field].value.from"
                placeholder="از"
              />

              <input
                type="text"
                :name="col.field"
                class="form-control two-input"
                v-model="gridView.filters[col.field].value.to"
                placeholder="تا"
              />
            </div>
          </div>
          <!--          <div class="form-group row " v-else-if="col.type=='multiSelect'">-->
          <!--            <div class="col-12">-->
          <!--              <label class="col-form-label">منطقه</label>-->
          <!--              <multiselect tag-placeholder="" placeholder="منطقه" selectLabel=""-->
          <!--                           deselectLabel="" selectedLabel="" v-model="address"-->
          <!--                           label="name" track-by="id" :options="$store.getters.getDistricts" :multiple="true"-->
          <!--                           :taggable="true"></multiselect>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="form-group row" v-else-if="col.type === 'select'">
            <label class="col-sm-3 col-form-label" v-html="col.label"></label>
            <div class="col-sm-9">
              <select
                class="form-control"
                v-model="gridView.filters[col.field].value"
              >
                <option
                  v-for="(item, index) in col.filterItems"
                  :key="index"
                  :value="item.code"
                  v-html="item.name"
                ></option>
              </select>
            </div>
          </div>
          <div class="form-group row" v-else-if="col.type === 'text'">
            <label class="col-sm-3 col-form-label" v-html="col.label"></label>
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                v-model="gridView.filters[col.field].value"
              />
            </div>
          </div>
        </template>
      </div>

      <div class="row">
        <div class="col-12">
          <hr />
        </div>
        <div class="col-12 d-flex justify-content-end">
          <b-button
            type="button"
            size="sm"
            class="btn btn-success"
            @click="runFilter"
            >اعمال فیلتر</b-button
          >
          <b-button
            type="button"
            size="sm"
            class="btn btn-danger mr-2"
            @click="cancelFilter()"
            >لغو فیلتر
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import datePicker from "vue-persian-datetime-picker";

export default {
  components: { datePicker },
  props: {
    rowCounter: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    defaultFilters: {
      type: Object,
      default: Object,
      required: false,
    },
    excelExport: {
      type: [String, Boolean],
      default: null,
      required: false,
    },
    autoRequest: {
      type: Boolean,
      default: true,
      required: false,
    },
    badgeFilter: {
      type: Boolean,
      default: false,
      required: false,
    },
    rowFilter: {
      type: Boolean,
      default: false,
      required: false,
    },
    adFilter: {
      type: Boolean,
      default: false,
      required: false,
    },
    urlQueryParams: {
      type: Boolean,
      default: false,
      required: false,
    },
    typingTime: {
      type: Number,
      default: 2,
      required: false,
    },
    badgeColor: {
      type: String,
      default: "badge-warning",
    },
  },
  data: () => ({
    typingTimer: null,
    gridView: {
      /* GridView Data */
      data: [],
      /* Filters Map */
      filters: {},

      /* Filters submitted */
      filterParams: {},
      /* GridView Params */
      totalItemsCount: 0,
      pageSize: 15,
      page: 1,
      sort: null,

      sortType: null,
      loading: false,
    },
    requestMethod: null,
  }),
  created() {
    this.gridView.filters = {};
    this.gridView.filterParams = {};

    /* create filters map */
    for (let item of this.columns) {
      if (
        item.type === "fromTo" ||
        item.type === "dateFromTo" ||
        item.type === "timeFromTo" ||
        item.type === "dateTimeFromTo" ||
        item.type === "priceFromTo"
      )
        this.gridView.filters[item.field] = {
          status: false,
          value: { from: null, to: null },
        };
      else this.gridView.filters[item.field] = { status: false, value: null };
    }
  },
  mounted() {
    if (this.autoRequest) {
      if (this.$route.query.page && Number(this.$route.query.page) > 0)
        this.gridView.page = Number(this.$route.query.page);
      else this.gridView.page = 1;

      /* set default filter to filters if default filter field is in filters */
      if (
        this.defaultFilters != null &&
        typeof this.defaultFilters == "object" &&
        Object.keys(this.defaultFilters).length
      ) {
        for (let item in this.defaultFilters) {
          if (this.gridView.filters[item]) {
            this.gridView.filters[item].status = true;
            this.gridView.filters[item].value = this.defaultFilters[item];
          }
        }
      }
      /* set filters by query filters */
      if (this.$route.query.filters) {
        for (let item in this.$route.query.filters) {
          if (this.gridView.filters[item]) {
            this.gridView.filters[item].status = true;
            this.gridView.filters[item].value = this.$route.query.filters[item];
          }
        }
      }
      this.runFilter(true);
    }
  },
  methods: {
    inputKeyUp(field = null, val = null) {
      this.typingTimer = setTimeout(() => {
        if (this.gridView.filterParams[field] != val) this.runFilter(val);
      }, 1500);
    },
    inputKeyDown() {
      clearTimeout(this.typingTimer);
    },
    setFilters(filter) {
      if (filter && typeof filter == "object") {
        for (let i in filter) {
          if (this.gridView.filters[i]) {
            this.gridView.filters[i].status = true;
            this.gridView.filters[i].value = filter[i];
          }
          this.gridView.filterParams[i] = filter[i];
        }
      }
      this.runFilter(filter);
    },
    runFilter(value = null) {
      if (value || value == "") {
        for (let key in this.gridView.filters) {
          if (this.gridView.filters[key].value != null) {
            let valueType = null;
            for (let i of this.columns)
              if (i.field == key) valueType = i.valueType;

            if (typeof this.gridView.filters[key].value == "object") {
              if (
                this.gridView.filters[key].value.from ||
                this.gridView.filters[key].value.to
              ) {
                this.gridView.filters[key].status = true;
                /* Create submitted Filters */
                if (valueType == "number")
                  this.gridView.filterParams[key] = [
                    Number(this.gridView.filters[key].value.from),
                    Number(this.gridView.filters[key].value.to),
                  ];
                else if (valueType == "string")
                  this.gridView.filterParams[key] = [
                    String(this.gridView.filters[key].value.from),
                    String(this.gridView.filters[key].value.to),
                  ];
                else
                  this.gridView.filterParams[key] = [
                    this.gridView.filters[key].value.from,
                    this.gridView.filters[key].value.to,
                  ];
              } else {
                this.gridView.filters[key].status = false;
                this.gridView.filters[key].value.from = null;
                this.gridView.filters[key].value.to = null;

                this.gridView.filterParams[key] = null;
              }
            } else {
              if (
                (this.gridView.filters[key].value != null &&
                  this.gridView.filters[key].value != "") ||
                typeof this.gridView.filters[key].value == "boolean"
              ) {
                this.gridView.filters[key].status = true;
                if (valueType == "number")
                  this.gridView.filterParams[key] = Number(
                    this.gridView.filters[key].value
                  );
                else if (valueType == "string")
                  this.gridView.filterParams[key] = String(
                    this.gridView.filters[key].value
                  );
                else if (valueType == "boolean") {
                  this.gridView.filterParams[key] =
                    this.gridView.filters[key].value == "true" ||
                    this.gridView.filters[key].value
                      ? true
                      : false;
                } else
                  this.gridView.filterParams[key] =
                    this.gridView.filters[key].value;
              } else {
                this.gridView.filters[key].status = false;
                this.gridView.filters[key].value = null;
                this.gridView.filterParams[key] = null;
              }
            }
          }
        }
        /* set default filter to submitted filter data */
        if (this.defaultFilters && typeof this.defaultFilters == "object")
          for (let item in this.defaultFilters)
            this.gridView.filterParams[item] = this.defaultFilters[item];

        let filterParams = {};

        for (let fp in this.gridView.filterParams)
          if (
            this.gridView.filterParams[fp] != null ||
            typeof this.gridView.filterParams[fp] == "boolean"
          )
            filterParams[fp] = this.gridView.filterParams[fp];

        this.gridView.filterParams = filterParams;

        if (this.urlQueryParams)
          this.$router.push({
            query: Object.assign({}, this.$route.query, {
              filters: this.gridView.filterParams,
            }),
          });
        if (this.adFilter) this.$bvModal.hide("adFilterModal");

        this.gridView.page = 1;
        this.loadGridView();
      }
    },
    cancelFilter(field = null) {
      if (field) {
        if (typeof this.gridView.filters[field].value === "object")
          this.gridView.filters[field].value = { from: null, to: null };
        else this.gridView.filters[field].value = null;
        this.gridView.filters[field].status = false;
        this.gridView.filterParams[field] = null;

        let obj = {};
        for (let i in this.gridView.filterParams)
          if (this.gridView.filterParams[i] != null)
            obj[i] = this.gridView.filterParams[i];

        this.gridView.filterParams = obj;
      } else {
        for (let f of Object.keys(this.gridView.filters)) {
          if (
            this.gridView.filters[f].value &&
            typeof this.gridView.filters[f].value == "object"
          )
            this.gridView.filters[f].value = { from: null, to: null };
          else this.gridView.filters[f].value = null;
          this.gridView.filters[f].status = false;
        }
        this.gridView.filterParams = {};
      }

      if (typeof this.defaultFilters == "object")
        for (let item in this.defaultFilters)
          this.gridView.filterParams[item] = this.defaultFilters[item];

      if (this.urlQueryParams)
        this.$router.push({
          query: Object.assign({}, this.$route.query, {
            filters: this.gridView.filterParams,
          }),
        });

      this.$bvModal.hide("adFilterModal");
      this.loadGridView();
    },
    async loadGridView() {
      if (this.url)
        try {
          this.gridView.loading = true;

          let params = {
            page: this.gridView.page,
            limit: this.gridView.pageSize,
            sort: this.gridView.sort,
          };

          // narang filter
          for (let key in this.gridView.filterParams) {
            params["filter." + key] = this.gridView.filterParams[key];
          }
          const qs = require("qs");
          let resp = await this.$axios.get(this.url, {
            params: params,
            paramsSerializer: qs.stringify,
          });

          this.gridView.data = resp.data.data;
          this.gridView.totalItemsCount = resp?.data?.meta?.total ?? (Array.isArray(resp?.data?.data) ? resp.data.data.length : 0); //Number(resp.data.pageMeta.totalItemsCount * this.gridView.pageSize);
          this.gridView.loading = false;
        } catch (e) {
          this.gridView.loading = false;
          this.gridView.data = [];
          //this.$getError(e)
        }
    },
    setSort(cName) {
      if (this.gridView.data.length) {
        if (this.gridView.sortType === "asc" && this.gridView.sort === cName) {
          this.gridView.sort = "-" + cName;
          this.gridView.sortType = "desc";
        } else if (
          this.gridView.sortType === "desc" &&
          this.gridView.sort === "-" + cName
        ) {
          this.gridView.sort = null;
          this.gridView.sortType = null;
        } else {
          this.gridView.sort = cName;
          this.gridView.sortType = "asc";
        }
        this.loadGridView();
      }
    },
    setSortClass(colName) {
      return {
        sort: true,
        "sort-asc": this.gridView.sort === colName,
        "sort-desc": this.gridView.sort === "-" + colName,
      };
    },
    async runExportExcel() {
      this.gridView["result-type"] = 1;
      const qs = require("qs");
      try {
        let params = {
          data: this.gridView.filterParams,
          sort: null,
          page_number: this.gridView.page,
          post_count: this.gridView.pageSize,
        };

        let res = await this.$axios.get(
          this.$axios.defaults.baseURL +
            this.excelExport +
            "?" +
            qs.stringify(params),
          {
            responseType: "blob",
          }
        );
        const url = URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.ms-excel",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `armitajmall-${new Date().toLocaleDateString()}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.log(e);
      }
    },
  },
  computed: {
    loading() {
      if (this.url) return this.gridView.loading;
      else return false;
    },
  },
  watch: {
    "gridView.page"(val) {
      if (this.gridView.data.length) {
        if (!val) this.gridView.page = 1;
        else if (
          val <=
          Math.ceil(this.gridView.totalItemsCount / this.gridView.pageSize)
        )
          if (this.urlQueryParams)
            this.$router.push({
              query: Object.assign({}, this.$route.query, { page: val }),
            });
        if (
          val <=
          Math.ceil(this.gridView.totalItemsCount / this.gridView.pageSize)
        ) {
          this.loadGridView();
        } else
          this.gridView.page = Math.ceil(
            this.gridView.totalItemsCount / this.gridView.pageSize
          );
      } else this.gridView.page = 1;
    },
    "gridView.pageSize"(val) {
      if (this.gridView.data.length) {
        this.gridView.page = 1;
        this.loadGridView();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.min-bode-height {
  min-height: 150px;
}

.two-input {
  display: flex;
  justify-content: space-between;

  input {
    width: 49%;
  }
}
</style>
